module.exports = __webpack_public_path__ + "img/7.6d7ca3df.jpeg";